<template>
  <div class="eCharts">
    <div class="imgCharts" id="main" ref="Charts"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      chartsInstance: null,
      allData: {
        xData: [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月'
        ],
        yData1: [100, 200, 300, 400, 500, 600, 500, 400, 900, 200, 100, 800],
        yData2: [100, 300, 300, 40, 50, 600, 50, 400, 30, 900, 10, 80],
        yData3: [10, 20, 300, 40, 540, 230, 530, 402, 30, 230, 130, 80]
      }
    }
  },
  mounted() {
    this.initCharts()
  },
  methods: {
    initCharts() {
      var myChart = this.$echarts.init(document.getElementById('main'))
      // 绘制图表
      myChart.setOption({
        title: {
          text: '近12个月的资金情况'
        },
        tooltip:{
          trigger:'axis'
        },
        xAxis: {
          type: 'category',
          data: this.allData.xData
        },
        yAxis: {
          type: 'value',
          scale:true
        },
        legend:{
          data:['充值金额','消费金额','提现金额']
        },
        series: [
          {
            name: '充值金额',
            type: 'bar',
            markPoint:{
              data:[
                {
                  type:'max',name:'最大值'
                },{
                  type:'min',name:'最小值'
                }
              ]
            },
            markLine:{
              data:[
                {
                  type:'average',name:'平均值'
                }
              ]
            },
            data: this.allData.yData1
          },
          {
            name: '消费金额',
            type: 'line',
            markPoint:{
              data:[
                {
                  type:'max',name:'最大值'
                },{
                  type:'min',name:'最小值'
                }
              ]
            },
             markLine:{
              data:[
                {
                  type:'average',name:'平均值'
                }
              ]
            },
            data: this.allData.yData2
          },
          {
            name: '提现金额',
            type: 'bar',
            markPoint:{
              data:[
                {
                  type:'max',name:'最大值'
                },{
                  type:'min',name:'最小值'
                }
              ]
            },
            markLine:{
              data:[
                {
                  type:'average',name:'平均值'
                }
              ]
            },
            data: this.allData.yData3
          }
        ]
      })
    }
  }
}
</script>
<style lang="scss">
.eCharts {
  width: 100%;
  height: 400px;
  // background-color: rgb(217, 231, 152);
  .imgCharts{
    width: 900px;
    height: 400px;
  }
}
</style>